(function ($) {
  $(document).ready(function () {
    $('.nav-opener').click(function () {
      $('body').toggleClass('nav-active');
      return false;
    });

    const list = document.querySelectorAll('.size-list li a');
    list.forEach((item) => {
      item.addEventListener('click', (e) => {
        list.forEach((el) => {
          el.classList.remove('active');
        });
        item.classList.add('active');
      });
    });

    const list1 = document.querySelectorAll('.prod-nav li a');
    list1.forEach((item) => {
      item.addEventListener('click', (e) => {
        list1.forEach((el) => {
          el.classList.remove('active');
        });
        item.classList.add('active');
      });
    });

    $('.color-list .color-title').click(function () {
      $(this).next('.slide').slideToggle('slow').siblings('.slide:visible').slideUp('slow');
      $(this).parent().toggleClass('active');
    });

    $('.promobar').slick({
      autoplay: true,
      arrows: false,
      dots: false,
      slidesToShow: 1,
      draggable: false,
      infinite: true,
      pauseOnHover: false,
      swipe: false,
      touchMove: false,
      vertical: true,
      speed: 1000,
      autoplaySpeed: 5000,
      useTransform: true,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            vertical: false,
          },
        },
      ],
    });

    $('.fundraising-gallery').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.press-gallery').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.wholesale-gallery').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.benefits-gallery').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.contact-gallery').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.trending-gallery').slick({
      infinite: false,
      prevArrow: $('.prev1'),
      nextArrow: $('.next1'),
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.lander-gallery').slick({
      slidesToScroll: 1,
      rows: 0,
      slidesToShow: 1,
      dots: true,
    });

    $('.instagram-gallery').slick({
      infinite: false,
      prevArrow: $('.prev2'),
      nextArrow: $('.next2'),
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.about-gallery').slick({
      infinite: false,
      prevArrow: $('.prev7'),
      nextArrow: $('.next7'),
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.feature-gallery').slick({
      infinite: false,
      prevArrow: $('.prev3'),
      nextArrow: $('.next3'),
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.product-gallery').slick({
      infinite: false,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.upsell-gallery').slick({
      infinite: false,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.partner-awards-slider').slick({
      infinite: true,
      prevArrow: $('.prev9'),
      nextArrow: $('.next9'),
      dots: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.malomo-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      adaptiveHeight: !0,
      dots: !1,
      arrows: !0,
      appendArrows: $('.related-arrow'),
      nextArrow: '<i class="fa fa-angle-right slider-arrow arrow-right" aria-hidden="true"></i>',
      prevArrow: '<i class="fa fa-angle-left slider-arrow arrow-left" aria-hidden="true"></i>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    //var $status = $('.count-slde');
    //var $slickElement = $('.product-slider');
    //$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //var i = (currentSlide ? currentSlide : 0) + 1;
    //$status.text(i + ' / ' + slick.slideCount);
    //});

    if (window.innerWidth < 1025) {
      $('.footer-section__columns .col-title').click(function () {
        $(this).next('.slide').slideToggle('slow').siblings('.slide:visible').slideUp('slow');
        $(this).parent().toggleClass('active');
      });
    }

    // accordion
    var holder = $('.faq-list');
    var options = {
      activeClass: 'active',
      clickOutsideDrop: true,
      slide: '.slide',
      animationSpeed: 200,
      opener: '.opener',
      targetElem: 'li',
    };

    holder.find(options.targetElem).each(function () {
      var self = $(this);

      if (!self.hasClass(options.activeClass)) {
        self.find(options.slide).hide();
      }
    });

    jQuery(options.opener).on('click', function (e) {
      e.preventDefault();
      var self = $(this);
      check(self);
    });

    win.on('click', function (e) {
      if (options.clickOutsideDrop === true) {
        if (holder.has(e.target).length == 0 && !holder.is(e.target)) {
          var slideHolder = $(holder.find(options.targetElem));
          // console.log(slideHolder);
          if (slideHolder.hasClass(options.activeClass)) {
            slideHolder.find(options.slide).slideUp(options.animationSpeed);
            slideHolder.removeClass(options.activeClass);
          }
        }
      }
    });

    function showSlide(self) {
      var parent = self.parent(options.targetElem);
      parent.find(options.slide).slideDown(options.animationSpeed);
    }

    function hideSlide(self) {
      var parent = self.parent(options.targetElem);
      parent.find(options.slide).slideUp(options.animationSpeed);
    }

    function check(self) {
      var parent = self.parent(options.targetElem);
      var siblings = parent.siblings();

      if (parent.hasClass(options.activeClass)) {
        parent.removeClass(options.activeClass);
        hideSlide(self);
      } else {
        parent.addClass(options.activeClass);
        showSlide(self);
        siblings.removeClass(options.activeClass);
        // console.log(siblings);
        siblings.find(options.slide).slideUp(options.animationSpeed);
      }
    }

    // end accordion
  });

  $(document).on('click', '.scroll-btn', function (event) {
    event.preventDefault();

    $('html, body').animate(
      {
        scrollTop: $($.attr(this, 'href')).offset().top,
      },
      500
    );
  });

  $(window).scroll(function () {
    var height = $(window).scrollTop();
    if (height > 1000) {
      $('.product-panel').addClass('fixed');
    } else {
      $('.product-panel').removeClass('fixed');
    }
  });

  $(window).scroll(function () {
    var height = $(window).scrollTop();
    if (height < 1000) {
      $('.prod-nav li a').removeClass('active');
    }
  });

  $(window).on('load', function () {
    var marquee = $('#marquee');
    marquee.css({ width: '100%', overflow: 'hidden' });
    marquee.wrapInner('<span>');
    var span = marquee.find('span');
    span.css({ whiteSpace: 'nowrap', display: 'inline-block' });

    var imgCount = span.find('img').length;
    var imgWidth = 128; // the width of each image
    var imgMargin = 40; // the total margin of each image (20px on each side)
    var totalWidth = (imgWidth + imgMargin) * imgCount + 40; // Adding extra space at the end

    span.css('width', totalWidth + 'px');

    marquee.append(span.clone());
    marquee.wrapInner('<div>');
    marquee.find('div').css('width', totalWidth * 2 + 'px');

    var reset = function () {
      $(this).css('margin-left', '0');
      $(this).animate({ 'margin-left': '-' + totalWidth + 'px' }, 31000, 'linear', reset); // Slightly increased animation time
    };

    reset.call(marquee.find('div'));
  });
})(jQuery);
